/**
 * Format a number as Nigerian Naira (₦) with comma separators and 2 decimal places.
 * @param {number|string} amount - The amount to format (e.g. 50000 or "50000")
 * @param {string} symbol - Currency symbol (default: "₦")
 * @returns {string} Formatted currency string (e.g. "₦50,000.00")
 */
export const formatCurrency = (amount, symbol = '₦') => {
  // Ensure amount is a number
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return `${symbol}0.00`;

  // Format with commas and 2 decimal places
  const formatted = num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return `${symbol}${formatted}`;
};

/**
 * Short version without decimal places (e.g. ₦50,000)
 * Useful for price tags where decimals are unnecessary.
 */
export const formatCurrencyShort = (amount, symbol = '₦') => {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return `${symbol}0`;
  return `${symbol}${Math.round(num).toLocaleString()}`;
};
